import React from 'react';
function Image({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect
        width="16"
        height="16"
        x="4"
        y="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx="2"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.889 10.222a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z"
        clipRule="evenodd"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 14.667l-4.444-4.445L5.777 20" />
    </svg>
  );
}

export default Image;
